import React, { FC } from 'react'
import DatePicker from 'react-datepicker'
import { Text } from '@shared/ui/Typography/Text'
import s from './DateRangeFilter.module.sass'
import BookingCalendarHeader from '@widgets/Restaurant/Booking/ui/components/BookingCalendar/BookingCalendarHeader'
import IconCalendar from '@icons/icon-owner-filter-calendar.svg'
import IconClose from '@icons/icon--x-thin-full.svg'

interface DateRangeFilterProps {
  startDate: Date | null
  endDate: Date | null
  onDateRangeChange: (startDate: Date | null, endDate: Date | null) => void
}

const DateRangeFilter: FC<DateRangeFilterProps> = ({ startDate, endDate, onDateRangeChange }) => {
  const formatDate = (date: Date) => {
    const day = date.getDate().toString()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    return `${day}.${month}`
  }

  const getDisplayText = () => {
    if (!startDate || !endDate) {
      return ''
    }
    const year = endDate.getFullYear()
    return `${formatDate(startDate)} – ${formatDate(endDate)}.${year}`
  }

  const handleClear = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    onDateRangeChange(null, null)
  }

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates
    onDateRangeChange(start, end)
  }

  const CalendarDayContent = (day: number, date: Date) => {
    const weekEndClassName = date.getDay() === 0 || date.getDay() === 6 ? 'react-datepicker__day-weekend' : ''
    return <span className={weekEndClassName}>{day}</span>
  }

  return (
    <div className={s.container}>
      <DatePicker
        selected={startDate}
        onChange={handleDateChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        customInput={
          <div className={s['filter-item']}>
            <div className={s['date-content']}>
              <div className={s['date-content-inner']}>
                <Text sizes='M' className={s['date-text']}>
                  {getDisplayText()}
                </Text>

                {startDate && endDate && (
                  <button className={s['clear-button']} onClick={handleClear} type='button'>
                    <IconClose className={s['clear-icon']} />
                  </button>
                )}
              </div>

              <div className={s['calendar-icon']}>
                <IconCalendar />
              </div>
            </div>
          </div>
        }
        locale='ru'
        dateFormat='dd.MM.yyyy'
        showPopperArrow={false}
        popperClassName={s['react-datepicker-popper']}
        calendarClassName={s['datepicker-calendar']}
        disabledKeyboardNavigation={false}
        renderDayContents={CalendarDayContent}
        renderCustomHeader={(data) => (
          <BookingCalendarHeader
            date={data.date}
            showYear={true}
            changeMonth={data.changeMonth}
            decreaseMonth={data.decreaseMonth}
            increaseMonth={data.increaseMonth}
            prevMonthButtonDisabled={data.prevMonthButtonDisabled}
            nextMonthButtonDisabled={data.nextMonthButtonDisabled}
          />
        )}
      />
    </div>
  )
}

export default DateRangeFilter
